import { i18n } from '../lang'

export default {
  //API_URL_BASE: "http://localhost:8080"
  API_URL_BASE:
    //"https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/pro_app",
    "https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/pro_app/v1",
  //  "https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/dev_test",
  // "https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/save_dev/v1",
    //"https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/dev_test/v1",
  //"https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/dev/v1",
  //API_URL_BASE:
  //  "https://ap-northeast-1.console.aws.amazon.com/apigateway/home?region=ap-northeast-1#/apis/n2hqv2gup4/stages/test_CORS"
  //API_URL_BASE:
  //  "https://04fp2yamn9.execute-api.ap-northeast-1.amazonaws.com/dev"
  API_URL_PAYMENT:
    "https://plnllof1z3.execute-api.ap-northeast-1.amazonaws.com/dev/payment",
  API_URL_PAYMENT_STATUS:
    "https://plnllof1z3.execute-api.ap-northeast-1.amazonaws.com/dev/payment_status",
  //"http://localhost:3000/payment"
  API_URL_PROCESS_CTRL:
    //"https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/error_handling/v1/process_control",
    "https://n2hqv2gup4.execute-api.ap-northeast-1.amazonaws.com/pro_app/v1/process_control",

  PAYMENT_LEVEL: {
    NONE: -1,
    FREE: 0,
    S: 10,
    M: 20,
    L: 30,
    PRE: 99
  },

  PAYMENT_NAME: {
    NONE: "？",
    FREE: i18n.t("FREE_USER"),
    S: i18n.t("S_USER"),
    M: i18n.t("M_USER"),
    L: i18n.t("L_USER"),
    PRE: i18n.t("PRE_USER")
  }
};



// WEBPACK FOOTER //
// ./src/common/Const.js